import React, { useContext } from "react";
import SelectionItem from "../../SelectionItem";
import Type1 from "./images/1.png";
import Type2 from "./images/2.png";
import Type3 from "./images/3.png";
import Type4 from "./images/4.png";
import "./index.scss";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const AdentySelect = ({
  selectStep
}) => {
  const {
    _t
  } = useTranslation();
  const {
    isPatient
  } = useContext(StepContext);
  const types = [{
    key: "partial",
    img: Type1,
    name: isPatient ? _t("Отсутствует один или небольшое количество зубов") : _t("Частичная адентия")
  }, {
    key: "adentyBottom",
    img: Type2,
    name: isPatient ? _t("Отсутствуют все зубы на нижней челюсти") : _t("Полная адентия на нижней челюсти")
  }, {
    key: "adentyTop",
    img: Type3,
    name: isPatient ? _t("Отсутствуют все зубы на верхней челюсти") : _t("Полная адентия на верхней челюсти")
  }, {
    key: "adentyBoth",
    img: Type4,
    name: isPatient ? _t("Отсутствуют все зубы на обеих челюстях") : _t("Полная адентия на обеих челюстях")
  }];

  function setStep(key) {
    selectStep(key);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "adentySelect"
  }, /*#__PURE__*/React.createElement("div", {
    className: "adentySelect-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    innerTitle: el.name
  }))));
};

export default AdentySelect;